import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonSvg } from '../Svg';
import { chameleonLaunchScreen } from './LaunchScreen.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonLaunchScreen({ prefix }), chameleonSvg({ prefix }));
}
